import { render } from "./DashboardMenu.vue?vue&type=template&id=675eb120&scoped=true"
import script from "./DashboardMenu.vue?vue&type=script&lang=js"
export * from "./DashboardMenu.vue?vue&type=script&lang=js"

import "./DashboardMenu.vue?vue&type=style&index=0&id=675eb120&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675eb120"]])

export default __exports__